export const FIELD_MAPPINGS = {
  countrytaxtype: 'countryTaxType',
  countrycode: 'countryCode',
  enabledflag: 'enabledFlag',
  description: 'description',
  currenttaxrate: 'taxRate',
  'currentp&l': 'plAccount',
  currentbs: 'bsAccount',
  deferredtaxrate: 'defTaxRate',
  'deferredp&l': 'defPlAccount',
  deferredbs: 'defBsAccount',
};

export const GRID_FIELD_MAPPINGS = {
  period: 'periodName',
  countrytaxtype: 'countryTaxType',
  countrycode: 'countryCode',
  enabledflag: 'enabledFlag',
  description: 'description',
  currenttaxrate: 'taxRate',
  'currentp&l': 'plAccount',
  currentbs: 'bsAccount',
  deferredtaxrate: 'defTaxRate',
  'deferredp&l': 'defPlAccount',
  deferredbs: 'defBsAccount',
};

export const columnHeaders = [
  'period',
  'countrytaxtype',
  'countrycode',
  'enabledflag',
  'description',
  'currenttaxrate',
  'currentp&l',
  'currentbs',
  'deferredtaxrate',
  'deferredp&l',
  'deferredbs',
];

export const MIN_COLUMNS_NUMBER = 11;
export const MAX_COLUMNS_NUMBER = 11;
